import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import SelectDateLoggedUser from "./SelectDateLoggedUser.jsx";
import { getDaysOfWeekend } from "../../store/selectors/selector.configOptions.jsx";
import { makeDaysOffForSelectDateSelector } from "../../store/selectors/selector.daysOff.jsx";

const SelectDateNonWorkingDays = ({
  type,
  userAvailability,
  userNonWorkingDaysLabel,
  userNonWorkingDays,
  ...props
}) => {
  const { t } = useTranslation();
  const getDaysOffForSelectDate = useMemo(() => makeDaysOffForSelectDateSelector(type), [type]);

  const weekends = useSelector(getDaysOfWeekend);
  const daysToModify = useSelector(getDaysOffForSelectDate);

  const finalDaysToModify = useMemo(() => {
    return [...userAvailability, ...daysToModify];
  }, [userAvailability, daysToModify]);

  return (
    <SelectDateLoggedUser
      {...props}
      weekends={weekends}
      weekendLabel={t("Weekend")}
      daysToModify={finalDaysToModify}
      userNonWorkingDays={userNonWorkingDays}
      userNonWorkingDaysLabel={userNonWorkingDaysLabel}
    />
  );
};

SelectDateNonWorkingDays.propTypes = {
  type: PropTypes.string,
  userAvailability: PropTypes.array,
  userNonWorkingDays: PropTypes.array,
  userNonWorkingDaysLabel: PropTypes.string,
};

SelectDateNonWorkingDays.defaultProps = {
  type: "global_day_off",
  userAvailability: [],
};

export default SelectDateNonWorkingDays;
